// extracted by mini-css-extract-plugin
module.exports = {"colWidth":"swiper_colWidth__8JNas","colWidthMobile":"swiper_colWidthMobile__mkr2B","wrapper":"swiper_wrapper__sh4dw","dragger":"swiper_dragger__GZ9ih"};